import { Button } from '@mui/material';
import classNames from 'classnames';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';

import { useLoginService } from '../../../services/loginService/index';
import { forgotPasswordState } from '../../../services/loginService/store';
import rootStyles from '../index.module.scss';
import formStyles from '../LoginContent/index.module.scss';
import styles from './index.module.scss';

function PasswordSentContent() {
  const {
    state: { forgotPassword, challenge, errorMessage },
  } = useLoginService();

  return (
    <div
      className={classNames(formStyles.root, rootStyles.boxContainer, 'w-full', {
        [rootStyles.hide]: forgotPassword.state !== forgotPasswordState.confirmed,
      })}
    >
      <div className={styles.content}>
        <span className={rootStyles.title}>Password was validated</span>
        <div className="font-normal text-neutrals-n-400 text-center text-base leading-snug ">
          You can now continue to the clinician dashboard.
        </div>
      </div>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        onClick={() => challenge?.onLogin?.()}
        className={clsx(formStyles.submitBtn, 'rounded-4')}
      >
        Continue
      </Button>
      {errorMessage ? <div className={formStyles.error}>{errorMessage}</div> : null}
    </div>
  );
}
export default observer(PasswordSentContent);
